<template>

    <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap" :class="isFlexible ? 'h-100' : 'h-80'" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        
        <div class="h-100" style="flex:3; position: relative;">
            <apexchart v-if="series && !thereIsNoData" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions" 
                :series="series" />
        </div>

        <div v-if="isFlexible && tableData" class="d-flex align-items-center justify-content-center flex-column h-100" style="flex:1">
            <ChartTable :tableData="tableData"/>
        </div>
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ChartTable from "./ChartTable.vue";
import {generateLabelDateArray, getHistoryGroupByStatus} from '@/components/chatter/util/graphUtils';
export default {
    name: 'projectPlanAndActualGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts,
        ChartTable
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        
        this.historyData = getHistoryGroupByStatus(this.dashboardData.history);
        if(this.historyData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                console.log("modify filter reload");
                
                this.series = [];
                this.chartOptions.xaxis.categories = [];
                this.reloadGraph();
            }
        },
    },
    data() {
        return {
            thereIsNoData:false,
            loading : false,
            historyData: '',
            columnNames: [],
            series: [],
            tableData:'',
            interval: 7,
            dateRange : [],
            chartOptions: {
                chart: {
                    height:'90%',
                    type: "line",
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                colors: ['#142459', '#1BD4D4'],
                markers: {
                    size: this.isFlexible ? 3 : 2,
                    strokeWidth: 1,
                },
                dataLabels: {
                    enabled: this.isFlexible, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                    style: {
                        fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                        colors: ['#fff'], // 데이터 라벨의 색상을 지정합니다.
                        fontWeight: 700,
                    },
                    // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                    offsetY: -10, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                    formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                        return val;
                    },
                    background: { // 데이터 라벨의 배경을 설정합니다.
                        enabled: true,
                        foreColor: '#2E2E38',
                        padding: 5,
                        borderRadius: 7,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        opacity: 1,
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    },
                    // 툴팁의 스타일 설정
                    enabled: true, // 툴팁 활성화 여부
                    shared: false, // 공유 툴팁 사용 여부 (true 또는 false)
                    // theme: 'dark', // 'dark' 또는 'light' (툴팁의 테마 설정)
                    // custom: function({ series, seriesIndex, dataPointIndex, w }) {
                    // return `<div class="custom-tooltip">${seriesIndex}</div>`;
                    // },
                    style: {
                        background: '#333',
                        color: '#fff',
                        fontSize: '14px',
                        padding: '8px',
                        borderRadius: '10px',
                        border: '1px solid #666',
                    },

                },
                stroke: {
                    width: [2, 2, 2, 2],
                    curve: 'straight',
                },
                xaxis: {
                    categories: [],
                    show:this.isFlexible,
                    axisTicks:this.isFlexible,
                    labels: {
                        show:this.isFlexible
                    },
                    tooltip: {
                        enabled: false
                    }
                    
                },
                yaxis: {
                    axisTicks:this.isFlexible,
                    labels: {
                        show:this.isFlexible
                    }
                },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                grid : {
                    show:false
                }
            },
        }
    },
    methods: {
        getLabelDateArray() {
            // from ~ to 구하기
            let planDateSet = new Set();
            let actualDateSet = new Set();

            // 날짜 정보 중복 제거
            for(let data of this.historyData) {
                if(data.planDate != '') {
                    planDateSet.add(data.planDate);
                }
                
                if(data.maxUpdatedDate != '') {
                    actualDateSet.add(data.maxUpdatedDate);
                }
            }

            // 배열로 변경
            let labelDateArray = [...planDateSet, ...actualDateSet];
            // let labelDateSet = [...planDateSet, ...actualDateSet];
            // let labelDateArray = [...new Set(labelDateSet)]; // 라벨데이터

            
            labelDateArray.sort((a, b) => new Date(a) - new Date(b));

            let from = labelDateArray[0];
            let to = labelDateArray[labelDateArray.length - 1];

            //여기서 eow를 사용하지 않아서 null 처리
            //graphUtils 에서 null로 받으면 프로젝트 첫 시작을로 처리하는 로직 있음
            let eow = null;
            let interval = 7;
            
            if(this.isFlexible) {
                if(this.filters.from != '') {
                    from = this.filters.from;
                }

                if(this.filters.to != '') {
                    to = this.filters.to;
                }

                if(this.filters.interval != '') {
                    interval = this.filters.interval;
                }
                
                if(this.filters.eow != '') {
                    eow = this.filters.eow;
                }
            }

            labelDateArray = generateLabelDateArray(from, to, labelDateArray, interval, eow);
            
            return labelDateArray;
        },

        countData(labelDateArray, dataArray) {

            const arraySize = labelDateArray.length;

            // 테이블 데이터
            let grandTotalCount = 0;
            let planTotalCount = 0;
            let actualTotalCount = 0;
            let progressRateComparedToTotal = 0;
            let progressRateComparedToToPlan = 0;

            let checkDupChatMap = new Map();

            let countObj = [
                {
                    name : '계획',
                    type : 'line',
                    data : new Array(arraySize).fill(0)
                },
                {
                    name : '실적',
                    type : 'column',
                    data : new Array(arraySize).fill(0)
                }
            ]

            let index = 0;
            let interval = 7;
            if(this.isFlexible) {
                interval = this.filters.interval != '' ? this.filters.interval : interval;
            }
            interval = Number(interval);
            for(let labelDate of labelDateArray) {

                let startDate = new Date(labelDate);
                let endDate = new Date(startDate);

                // 중복 카운트 확인

                endDate.setDate(endDate.getDate() + interval);

                dataArray.forEach(item=> {

                    if(!checkDupChatMap.has(item.chatId)) {
                        grandTotalCount++;
                        checkDupChatMap.set(item.chatId, item.chatId);
                    }

                    let planDate = new Date(item.planDate);
                    let actualDate = new Date(item.maxUpdatedDate);
                    
                    if(item.status == 'TO_DO' && (startDate <= planDate && planDate < endDate)) {        
                        countObj[0]['data'][index]++;
                        planTotalCount++;
                    } else if(item.status == 'DONE' && (startDate <= actualDate && actualDate < endDate)) {
                        countObj[1]['data'][index]++;
                        actualTotalCount++;
                    }
                });
                index++;
            }

            progressRateComparedToTotal = (actualTotalCount / grandTotalCount * 100).toFixed(2) + '%'
            progressRateComparedToToPlan = (planTotalCount / grandTotalCount * 100).toFixed(2) + '%'            

            // this.currentChatterData.forEach(data => {
            //     grandTotalCount++;
            //     if(data.dueDate != '') {
            //         planTotalCount++;
            //     }
            //     switch (data.status) {
            //         case 'TO_DO':
            //         case 'IN_PROGERSS':
            //     }
            // });


            this.tableData = {                 
                "index": [
                        "전체",
                        "계획",
                        "완료",
                        "전체 대비 진척률",
                        "계획 대비 진척률"
                    ],
                "Count": [grandTotalCount, planTotalCount, actualTotalCount, progressRateComparedToTotal, progressRateComparedToToPlan],
            }

            return countObj;
        },

        visualizeGraph() {
            
            let dataArray = this.historyData;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;


                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                dataArray = dataArray.filter(item => {
                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) &&
                        BUSINESS_CATEGORY.includes(item.businessCategory) 
                    );
                });
            }
            
            let labelDateArray = this.getLabelDateArray();

            let countObj = this.countData(labelDateArray, dataArray);
        
            this.series = countObj;
            this.label = labelDateArray;

            this.setLabels();
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            this.chartOptions.xaxis.categories = this.label;

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions({
                    xaxis: {
                        categories: this.label,
                    },
                });
            }
        },

        reloadGraph2() {
            // 필터 값 초기화
            let L1 = this.filters.L1;
            let L2 = this.filters.L2;
            let L3 = this.filters.L3;
            let JOB = this.filters.JOB;
            let PRIORITY = this.filters.PRIORITY;
            let TYPE = this.filters.TYPE;

            // from ~ to 구하기
            let planDateSet = new Set();
            let actualDateSet = new Set();

            // 날짜 정보 중복 제거
            for(let data of this.graphData.data) {
                if(data.planDate != '') {
                    planDateSet.add(data.planDate);
                }
                
                if(data.maxUpdatedDate != '') {
                    actualDateSet.add(data.maxUpdatedDate);
                }
            }

            // 배열로 변경
            let planDateArray = [...planDateSet];
            let actualDateArray = [...actualDateSet];

            // 계획, 실제 데이터 비교 후 from, to 저장
            if(from === '') {
                from = new Date(planDateArray[0]) > new Date(actualDateArray[0]) ? actualDateArray[0] : planDateArray[0]
            }

            if(to === '') {
                let planDateArraylastDate = planDateArray[planDateArray.length - 1];
                let actualDateArraylastDate = actualDateArray[actualDateArray.length - 1];

                to = new Date(planDateArraylastDate) > new Date(actualDateArraylastDate) ? planDateArraylastDate : actualDateArraylastDate;
            }

            // interval값을 사용하여 form ~ to 사이의 날짜 label 구하기
            this.dateRange = this.generateDateRange(from, to, 7 );
        
            // None 값을 ""로 변경
            // L1 = L1.map(value => value === "None" ? "" : value);
            // L2 = L2.map(value => value === "None" ? "" : value);
            // L3 = L3.map(value => value === "None" ? "" : value);
            // JOB = JOB.map(value => value === "None" ? "" : value);
            // PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
            // TYPE = TYPE.map(value => value === "None" ? "" : value);

            // // 필터 값을 사용하여 데이터 필터링
            // let filteredData = this.graphData.data.filter(item => {
            //     return (
            //         L1.includes(item.l1) &&
            //         L2.includes(item.l2) &&
            //         L3.includes(item.l3) &&
            //         JOB.includes(item.job) &&
            //         PRIORITY.includes(item.priority) &&
            //         TYPE.includes(item.type)
            //     );
            // });                    

            // const seriesLabelArray = ['계획', '실적'];

            // let countObj = {}
            // seriesLabelArray.forEach(item => {
            //     countObj[item] = new Array(labelDateArray).fill(0);
            // })

            // // labelDateArray을 순회하면서 데이터 카운트
            // labelDateArray.forEach(date =>{
            //     let idx = 0;
            //     for(let data of filteredData) {
                    
            //     }
            // });

            

            // let planData = filteredData.map(item => item.planDate);
            // let uniquePlanData = [...new Set(planData)]; // 라벨데이터
            // uniquePlanData.sort((a, b) => new Date(a) - new Date(b));
            // // 각 날짜를 해당 주의 월요일로 변환하여 배열에 담기
            // // 각 날짜를 해당 주의 월요일로 변환하여 yyyy-mm-dd 형식으로 표기하고 중복 제거
            

            // let mondayDates = uniquePlanData.map(dateStr => {
            //     if(dateStr != 'TBD') {
                
            //         let currentDate = new Date(dateStr);
            //         let dayOfWeek = currentDate.getDay(); // 0: 일요일, 1: 월요일, ... , 6: 토요일
            //         let diffDays = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
            //         let mondayDate = new Date(currentDate);
            //         mondayDate.setDate(currentDate.getDate() - diffDays);
            //         return mondayDate.toISOString().slice(0, 10); // yyyy-mm-dd 형식으로 변환
            //     }
            // });

            // // 중복 제거된 날짜 목록
            // let uniqueMondayDates = [...new Set(mondayDates)];
            // // this.response.label = [];
            // // this.response.label = uniqueMondayDates;

            // let countPlan = [];
            // let planTotalCount = 0;
            // let totalRowCount = 0 ;
            // this.flexableGraphData.series[0].data = [];
            // for (let mondayDate of uniqueMondayDates) {
            //     let count = 0;
            //     for (let item of filteredData) {
            //         let itemPlanDate = item.planDate;

            //         // item.planDate 값이 null이거나 ''인 경우 다음으로 넘어가기
            //         if (itemPlanDate === null || itemPlanDate === 'TBD') {
            //             continue;
            //         }

            //         if(!('SSG' == this.projectId || 'SSG-PL' == this.projectId || 'SSG-PO' == this.projectId)) {
            //             if(item.status != 'TO_DO') {
            //                 continue;
            //             }
            //         }

            //         itemPlanDate = new Date(item.planDate);
            //         let itemPlanWeekStart = new Date(itemPlanDate);
            //         itemPlanWeekStart.setDate(itemPlanDate.getDate() - itemPlanDate.getDay() + 1); // 월요일 날짜 계산

            //         if (itemPlanWeekStart.toISOString().slice(0, 10) === mondayDate) {
            //             totalRowCount++;
            //             count++;
            //         }

            //         if (itemPlanWeekStart.toISOString().slice(0, 10) === mondayDate && itemPlanDate < new Date()) {
            //             planTotalCount++;
            //         }

            //     }
            //     countPlan.push(count)
            // }
            
            // let countActual = [];
            // let actualTotalCount = 0;
            // this.flexableGraphData.series[1].data = [];
            // for (let mondayDate of uniqueMondayDates) {
            //     let count = 0;
            //     for (let item of filteredData) {
            //     let itemActualDate = item.actualDate;

            //     // item.planDate 값이 null이거나 ''인 경우 다음으로 넘어가기
            //     if (itemActualDate === null || itemActualDate === 'TBD') {
            //         continue;
            //     }

            //     itemActualDate = new Date(item.actualDate);
            //     let itemActualWeekStart = new Date(itemActualDate);
            //     itemActualWeekStart.setDate(itemActualDate.getDate() - itemActualDate.getDay() + 1); // 월요일 날짜 계산

            //     if ((item.status === 'DONE') && itemActualWeekStart.toISOString().slice(0, 10) === mondayDate) {
            //         count++;
            //         actualTotalCount++;
            //     }
            //     }
            //     // countActual[mondayDate] = count;
            //     // this.response.series[1].data.push(count)
            //     countActual.push(count)
            // }

            // let totalPerDone = (actualTotalCount / totalRowCount * 100).toFixed(2) + '%'
            // let planPerDone = (actualTotalCount / planTotalCount * 100).toFixed(2) + '%'
            // this.flexableGraphData = {
            //     "series": [
            //     {
            //         "name": "계획",
            //         "type": "line",
            //         "data": countPlan
            //     },
            //     {
            //         "name": "실적",
            //         "type": "column",
            //         "data": countActual
            //     }
            //     ],
            //     "label": uniqueMondayDates,
            //     "table": {                 
            //         "index": [
            //                 "전체",
            //                 "계획",
            //                 "완료",
            //                 "전체 대비 진척률",
            //                 "계획 대비 진척률"
            //             ],
            //     "Count": [totalRowCount, planTotalCount, actualTotalCount, totalPerDone, planPerDone],
            //             }
            // };

            // this.flexableGraphTableData = this.flexableGraphData.table;
        },
    },
}
</script>
<style>
.apexcharts-tooltip {
    border-radius: 20px;
}

.h-80 {
    padding-top: 10px;
    height: 80%;
}
</style>
